import { DISMISS_IMPERSONATION_BLOCKED, SHOW_IMPERSONATION_BLOCKED } from './actionTypes';
import { Action } from './commonActions';

export function showImpersonationBlocked(): Action<{}> {
  return {
    type: SHOW_IMPERSONATION_BLOCKED,
  };
}

export function dismissImpersonationBlocked(): Action<{}> {
  return {
    type: DISMISS_IMPERSONATION_BLOCKED,
  };
}
